import React from 'react';
import accept from '@icons/accept.svg';
import addFilter from '@icons/add-filter.svg';
import blueMinus from '@icons/add-minus.svg';
import minusWhite from '@icons/add-minus-white.svg';
import bluePlus from '@icons/add-plus.svg';
import plusWhite from '@icons/add-plus-white.svg';
import affiliar from '@icons/affiliar.svg';
import affiliarMark from '@icons/affiliar-mark.svg';
import logo from '@icons/affiliar.svg';
import affiliarDark from '@icons/affiliar-dark.svg';
import alertGray from '@icons/alert-gray.svg';
import alertOrange from '@icons/alert-orange.svg';
import betamericanoShort from '@icons/americanoShort.svg';
import andarBaharTeenPatti from '@icons/andar-bahar-teen-patti.svg';
import arrowBg from '@icons/arrow-bg.svg';
import arrowRight from '@icons/arrow-right.svg';
import arrowRightWithBg from '@icons/arrow-right-with-bg.svg';
import avatarCircle from '@icons/avatar-circle.svg';
import baccarat from '@icons/baccarat.svg';
import backIcon from '@icons/back-Icon.svg';
import basketball from '@icons/basketball.svg';
import basketballSmall from '@icons/basketball-small-icon.svg';
import betamericanoLogo from '@icons/betamericano-logo.svg';
import betroxy from '@icons/betroxy.svg';
import blackjack from '@icons/blackjack.svg';
import blueDropdown from '@icons/blue-dropdown.svg';
import blueTickCircle from '@icons/blue-tick-circle.svg';
import blueCheckbox from '@icons/BlueCheckbox.svg';
import bonus from '@icons/bonus.svg';
import bookOpen from '@icons/book-open.svg';
import brandedGames from '@icons/branded-games.svg';
import buyBonusSlots from '@icons/buy-bonus-slots.svg';
import calculate from '@icons/calculate.svg';
import calendar from '@icons/calendar.svg';
import whiteCancel from '@icons/cancel-white.svg';
import canceled from '@icons/canceled.svg';
import cardDeposit from '@icons/card-deposit.svg';
import casino from '@icons/casino.svg';
import providerChip from '@icons/casino-chip.svg';
import casinoLogo from '@icons/casino-logo.svg';
import category from '@icons/category.svg';
import categoryIcon2 from '@icons/category-2.svg';
import categoryChip from '@icons/category-big.svg';
import fa2 from '@icons/change-icon.svg';
import changeBlue from '@icons/changeIcon.svg';
import checkbox from '@icons/Checkbox.svg';
import checkedstar from '@icons/checked-star.svg';
import cherryChip from '@icons/cherry.svg';
import cherryGame from '@icons/cherry-game.svg';
import classicSlots from '@icons/classic-slots-fruit-slots.svg';
import clock from '@icons/clock.svg';
import cancelCloseGray from '@icons/close-cancel-gray.svg';
import closeCircle from '@icons/close-circle.svg';
import cny from '@icons/cny.svg';
import colorfulSkeletonLines from '@icons/colorful-skeleton-lines.svg';
import copy from '@icons/copy.svg';
import country from '@icons/country.svg';
import craps from '@icons/craps.svg';
import crashGames from '@icons/crash-games.svg';
import cricket from '@icons/cricket.svg';
import cricketSmall from '@icons/cricket-small-icon.svg';
import currency from '@icons/currencytree.svg';
import daily from '@icons/dailyicon.svg';
import defaultLogoWhite from '@icons/default-logo-white.svg';
import diceSicBo from '@icons/dice-sic-bo.svg';
import down from '@icons/down.svg';
import downArrow from '@icons/down-arrow.svg';
import downArrowRed from '@icons/down-arrow-red.svg';
import download from '@icons/download.svg';
import downloadGreen from '@icons/download-green.svg';
import edit from '@icons/edit.svg';
import editBlue from '@icons/edit-blue-pen.svg';
import editGray from '@icons/edit-gray-pen.svg';
import editPen from '@icons/edit-pen.svg';
import ellipse3 from '@icons/ellipse3.svg';
import ellipse10 from '@icons/ellipse10.svg';
import ellipse20 from '@icons/ellipse20.svg';
import emptyWalletAdd from '@icons/empty-wallet-add.svg';
import england from '@icons/england.svg';
import euro from '@icons/euro.svg';
import facebook from '@icons/facebook.svg';
import failed from '@icons/failed.svg';
import fileupload from '@icons/fileupload.svg';
import filter from '@icons/filter.svg';
import filterWhite from '@icons/filter-white.svg';
import football from '@icons/football.svg';
import footballSmall from '@icons/football-small-icon.svg';
import FR from '@icons/france.svg';
import gameShows from '@icons/game-shows.svg';
import games from '@icons/games-icon.svg';
import gbp from '@icons/gbp.svg';
import globalLimit from '@icons/globalLimit.svg';
import goButton from '@icons/go-button.svg';
import grayPlus from '@icons/gray-plus.svg';
import graySkeletonLines from '@icons/gray-skeleton-lines.svg';
import greenTick from '@icons/green-tick.svg';
import greenUp from '@icons/green-up.svg';
import highRollerGames from '@icons/high-roller-games.svg';
import highTendency from '@icons/high-tendency.svg';
import hkd from '@icons/hkd.svg';
import indigoDownArrow from '@icons/indigo-down-arrow.svg';
import indigoUpArrow from '@icons/indigo-up-arrow.svg';
import inr from '@icons/inr.svg';
import instantWin from '@icons/instant-win.svg';
import italy from '@icons/italy.svg';
import jackpotGames from '@icons/jackpot-games.svg';
import level0 from '@icons/level-0.svg';
import level1 from '@icons/level-1.svg';
import level2 from '@icons/level-2.svg';
import level3 from '@icons/level-3.svg';
import level4 from '@icons/level-4.svg';
import liveBaccarat from '@icons/live-baccarat.svg';
import liveBlackjack from '@icons/live-blackjack.svg';
import liveCasino from '@icons/live-casino.svg';
import livePoker from '@icons/live-poker.svg';
import liveRoulette from '@icons/live-roulette.svg';
import lost from '@icons/lost.svg';
import lowTendency from '@icons/low-tendency.svg';
import mathPlus from '@icons/math-plus.svg';
import mediumTendency from '@icons/medium-tendency.svg';
import megawaysSlots from '@icons/megaways-slots.svg';
import miniGames from '@icons/mini-games.svg';
import moneyWheel from '@icons/money-wheel.svg';
import monthly from '@icons/monthlyicon.svg';
import move from '@icons/move.svg';
import newRelease from '@icons/new-release.svg';
import notification from '@icons/notification.svg';
import payment from '@icons/payment.svg';
import performance from '@icons/performance.svg';
import playerCircle from '@icons/player-circle.svg';
import players from '@icons/players.svg';
import pokerRng from '@icons/poker-rng.svg';
import popularGames from '@icons/popular-games.svg';
import close from '@icons/popup-close.svg';
import closeGray from '@icons/popup-close-gray.svg';
import profileSite from '@icons/profile-site.svg';
import promotion from '@icons/promotion.svg';
import provider from '@icons/provider.svg';
import question from '@icons/question.svg';
import readed from '@icons/readed.svg';
import redDown from '@icons/red-down.svg';
import referal from '@icons/referal.svg';
import reject from '@icons/reject.svg';
import removeFilter from '@icons/remove-filter.svg';
import ReportIcon from '@icons/report.svg';
import returned from '@icons/returned.svg';
import rightArrow from '@icons/right-arrow.svg';
import roulette from '@icons/roulette.svg';
import betroxySmall from '@icons/roxysmall.svg';
import rsd from '@icons/rsd.svg';
import ruinbetLogo from '@icons/Ruinbet-Logo.svg';
import search from '@icons/search.svg';
import searchWhite from '@icons/search-white.svg';
import selected from '@icons/selected.svg';
import settings from '@icons/settings.svg';
import ruinbetShort from '@icons/short-ruinbet.svg';
import carouselRightIcon from '@icons/slider-arrow-right.svg';
import slots from '@icons/slots.svg';
import defaultSmall from '@icons/small-default.svg';
import star from '@icons/star.svg';
import success from '@icons/success.svg';
import tableGames from '@icons/table-games.svg';
import tennis from '@icons/tennis.svg';
import whiteStar from '@icons/the-star-white-bg.svg';
import theStarSolo from '@icons/thestar-solo.svg';
import tick from '@icons/tick.svg';
import topGames from '@icons/top-games.svg';
import trashCan from '@icons/trash.svg';
import trashRed from '@icons/trash-red.svg';
import trashWhite from '@icons/trash-white.svg';
import trendingNow from '@icons/trending-now.svg';
import tl from '@icons/try.svg';
import unCheckedbox from '@icons/uncheckbox.svg';
import UK from '@icons/united-kingdom.svg';
import unread from '@icons/unread.svg';
import up from '@icons/up.svg';
import upArrowGreen from '@icons/up-arrow-green.svg';
import usd from '@icons/usd.svg';
import usdt from '@icons/usdt.svg';
import userBlue from '@icons/user-blue.svg';
import userCircleAdd from '@icons/user-circle-add.svg';
import userPen from '@icons/user-pen.svg';
import userProfile from '@icons/user-profile.svg';
import verifiedTick from '@icons/verified-tick.svg';
import videoCircle from '@icons/video-circle.svg';
import view from '@icons/view.svg';
import viewGreen from '@icons/view-green.svg';
import vipTables from '@icons/vip-tables.svg';
import virtualGames from '@icons/virtual-games.svg';
import volleyball from '@icons/volleyball.svg';
import warning from '@icons/warning.svg';
import warningTriangle from '@icons/warning-triangle.svg';
import weekly from '@icons/weeklyicon.svg';
import whatsapp from '@icons/whatsapp.svg';
import whiteArrow from '@icons/white-arrow.svg';
import withdraw from '@icons/withdraw.svg';
import withdrawal from '@icons/withdrawal.svg';
import won from '@icons/won.svg';
import cx from 'classnames';

type IconProps = {
  iconName: string;
  className?: string;
  svgProps?: React.SVGProps<SVGSVGElement>;
  iconclass?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  disabled?: boolean;
};

type IconMap = {
  [key: string]: string;
};

const icons: IconMap = {
  accept,
  addFilter,
  affiliar,
  affiliarMark,
  affiliarDark,
  alertOrange,
  alertGray,
  arrowRightWithBg,
  calculate,
  avatarCircle,
  backIcon,
  daily,
  weekly,
  monthly,
  arrowRight,
  arrowBg,
  ruinbetLogo,
  ruinbetShort,
  theStarSolo,
  defaultLogoWhite,
  defaultSmall,
  basketball,
  basketballSmall,
  betroxy,
  betroxySmall,
  blueCheckbox,
  blueDropdown,
  blueMinus,
  bluePlus,
  grayPlus,
  blueTickCircle,
  bonus,
  bookOpen,
  calendar,
  fa2,
  globalLimit,
  canceled,
  cardDeposit,
  carouselRightIcon,
  casino,
  casinoLogo,
  category,
  categoryChip,
  categoryIcon2,
  changeBlue,
  checkbox,
  betamericanoShort,
  checkedstar,
  cherryChip,
  cherryGame,
  clock,
  close,
  closeCircle,
  closeGray,
  cny,
  colorfulSkeletonLines,
  trashWhite,
  copy,
  country,
  cricket,
  cricketSmall,
  currency,
  down,
  downArrow,
  downArrowRed,
  download,
  downloadGreen,
  edit,
  editBlue,
  editPen,
  ellipse10,
  ellipse20,
  ellipse3,
  emptyWalletAdd,
  england,
  euro,
  facebook,
  failed,
  fileupload,
  filter,
  filterWhite,
  football,
  footballSmall,
  editGray,
  FR,
  games,
  gbp,
  goButton,
  graySkeletonLines,
  greenTick,
  greenUp,
  highTendency,
  hkd,
  indigoDownArrow,
  indigoUpArrow,
  inr,
  italy,
  level0,
  level1,
  level2,
  level3,
  level4,
  logo,
  lost,
  lowTendency,
  mathPlus,
  mediumTendency,
  minusWhite,
  moneyWheel,
  move,
  notification,
  payment,
  performance,
  playerCircle,
  players,
  plusWhite,
  profileSite,
  promotion,
  provider,
  providerChip,
  question,
  readed,
  redDown,
  referal,
  reject,
  removeFilter,
  report: ReportIcon,
  returned,
  rightArrow,
  rsd,
  search,
  searchWhite,
  selected,
  settings,
  star,
  success,
  slots,
  tennis,
  tick,
  tl,
  trashCan,
  trashRed,
  UK,
  unCheckedbox,
  up,
  upArrowGreen,
  usd,
  usdt,
  userBlue,
  userCircleAdd,
  userPen,
  userProfile,
  verifiedTick,
  videoCircle,
  volleyball,
  warning,
  whatsapp,
  whiteArrow,
  whiteCancel,
  whiteStar,
  withdraw,
  withdrawal,
  won,
  unread,
  view,
  cancelCloseGray,
  andarBaharTeenPatti,
  baccarat,
  blackjack,
  brandedGames,
  buyBonusSlots,
  classicSlots,
  craps,
  diceSicBo,
  highRollerGames,
  instantWin,
  jackpotGames,
  liveBaccarat,
  liveBlackjack,
  livePoker,
  liveRoulette,
  megawaysSlots,
  miniGames,
  newRelease,
  pokerRng,
  popularGames,
  tableGames,
  topGames,
  trendingNow,
  vipTables,
  virtualGames,
  liveCasino,
  roulette,
  gameShows,
  crashGames,
  viewGreen,
  warningTriangle,

  betamericanoLogo,
};

export const Icon: React.FC<IconProps> = ({
  iconName,
  svgProps = { width: 24, height: 24, fill: 'currentColor' },
  disabled,
  className,
  ...props
}) => {
  const classNames = cx(className, {
    'pointer-events-none': disabled,
    'cursor-pointer': props?.onClick,
  });

  const SvgIcon = icons[iconName];
  if (!SvgIcon) return null;
  return (
    <div
      className={`flex flex-row justify-center items-center ${classNames} shrink-0`}
      data-testid={iconName}
      {...props}
    >
      <SvgIcon
        {...{
          'aria-hidden': 'true',
          role: 'img',
          focusable: 'false',
          preserveAspectRatio: 'xMidYMid meet',
          ...svgProps,
        }}
      />
    </div>
  );
};

export default Icon;
